// External libraries
import React from 'react';
import { LoadingElement } from '@/components/Common';

// Internal modules
import { logger } from '@/lib/logger';
import { features, getLazyLoaderRenderFunction, lazyLoader } from '@/lib';

// If we are not in an optional signup flow then the password fields
// are rendered on page load, so we need to track the lading status
if (features.isNotActive('isOptionalSignup')) {
  logger.fptiTrackPageLoad.registerItem('PasswordInput');
}

const LazyPasswordInput = lazyLoader({
  loader: () => import('./PasswordInput'),
  loading: () => <LoadingElement />,
  name: 'password_input',
  render: getLazyLoaderRenderFunction({ componentName: 'PasswordInput' }),
});

export { LazyPasswordInput };
